import { render, staticRenderFns } from "./BoardSubTitle.vue?vue&type=template&id=740848a5&scoped=true"
import script from "./BoardSubTitle.vue?vue&type=script&lang=js"
export * from "./BoardSubTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740848a5",
  null
  
)

export default component.exports